import { render, staticRenderFns } from "./BvaApp.vue?vue&type=template&id=4d6dcbb1&scoped=true&"
import script from "./BvaApp.vue?vue&type=script&lang=ts&"
export * from "./BvaApp.vue?vue&type=script&lang=ts&"
import style0 from "./BvaApp.vue?vue&type=style&index=0&id=4d6dcbb1&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d6dcbb1",
  null
  
)

export default component.exports